import React, { useState } from "react";
import "../style/VideoCentre.css";
import LeaveMessage from "./LeaveMessage";


const Videocentre = () => {
  const [open, setOpen] = useState(false);


  const videos = [
    { id: "AM45 DC OBSTACLE TUBULAR MOTOR" , src: "/video-file/1.mp4", link: "https://youtu.be/zIAx5C2rZXs?si=MvBWggcRSywJGwEg" },
    { id: "AC153-06 TIMING EMITTER", src: "/video-file/2.mp4", link: "https://youtu.be/o135giykrHE?si=EBSZtOIa3lbIr6_m" },
    { id: "AM35-6/28-MEL-ZG, ZERO GAP TUBULAR MOTOR " , src: "/video-file/3.mp4", link: "https://youtu.be/mskFWNhZ6Pg?si=YTA5z2lc6lRfZKaT" },
    { id: "AM50 EXTERNAL BATTERY DC CURTAIN MOTOR" , src: "/video-file/4.mp4", link: "https://youtu.be/x23rLi7iB5I?si=wRUPvOf5Dow5q_ZF" },
    { id: "AM95 MAGNETIC LEVITATION CURTAIN MOTOR ", src: "/video-file/5.mp4", link: "https://youtu.be/kDipE67DT-E?si=iLHe2ONBWqlUiTYf" },
    { id: "AM75 QUIET CURTAIN MOTOR ", src: "/video-file/6.mp4", link: "https://youtu.be/Nm4m3fpHExI?si=XZEANwHlPPhaWlFx" },
    { id: "AM75 EXTERNAL BATTERY CURTAIN MOTOR", src: "/video-file/7.mp4", link: "https://youtu.be/73d4s5ZUKFk?si=JvgjLVyPBEG4dGo2" },
    { id: "AC152 SCROLL WHEEL EMITTER", src: "/video-file/8.mp4", link: "https://youtu.be/AK81sAvGjX4?si=SBhiyji3_78ihTNn" },
    { id: "A-OK MOTORIZED ZIP SCREEN BLINDS VIDEO", src: "/video-file/9.mp4", link: "https://youtu.be/xIOD6qxJO2k?si=tos_X9aGXwZ6-rQH" },
    { id: "AM35 PARALLEL CONNECTION TUBULAR MOTOR", src: "/video-file/10.mp4", link: "https://youtu.be/_Bs1_B87_rU?si=h_nE5sjGao6RG3cs" },
    { id: "A-OK Motorized ZIP screen blinds video", src: "/video-file/11.mp4", link: "https://youtu.be/zrbsjtWcKc8" },
    { id: "AMC 50 MOTORIZED VERTICAL BLINDS SYSTEM", src: "/video-file/12.mp4", link: "https://youtu.be/tcV1IxZHr7g" },
    { id: "AM93 Mini Curtain Motor ", src: "/video-file/14.mp4", link: "https://youtu.be/EB-GTvVOc9A " },
    { id: "A-OK OBSTACLE ZIP SCREEN MOTOR ", src: "/video-file/15.mp4", link: "https://youtu.be/nJGrdb698GY " },
    { id: "A-OK Plantation shutter motor ", src: "/video-file/16.mp4", link: "https://youtu.be/LZl3swmvw2Q " },
    { id: "A-OK AM36 WINDOW OPENNER ", src: "/video-file/17.mp4", link: "https://youtu.be/5eyj1KyBmuM " },
    { id: "A-OK AM28 SUPER SILENT MOTOR ", src: "/video-file/18.mp4", link: "https://youtu.be/8NON5aru2Y4" },
    { id: "A-OK AM40 VENETIAN BLINDS DRIVE ", src: "/video-file/19.mp4", link: "https://youtu.be/B28itVMtm0Q " },

  ];

  return (
    <>
  
      <div id="searchResults"></div>

     <LeaveMessage />

   
      <section>
        <div className="heading-section">
          <h2>VIDEO CENTRE</h2>
        </div>
      </section>

      <section className="video-grid">
        {videos.map((video) => (
          <div key={video.id} className="video-wrapper">
            <a href={video.link} target="_blank" rel="noreferrer">
              <video src={video.src}></video>
              <div className="play-button">
                <div className="pulse-ring"></div>
                <div className="icon">▶</div>
              </div>
            </a>
            <div className="video-btn"> {video.id}</div>
          </div>
        ))}
      </section>
    </>
  );
};

export default Videocentre;
